/**
 * Block all inline scripts (e.g. <script>...</script>) to prevent
 * them from running when a fragment is loaded. This is a security
 * measure to prevent any inline scripts from executing, which can
 * help mitigate certain types of cross-site scripting (XSS) attacks.
 * https://unpoly.com/script-security#script-elements
 */
up.script.config.scriptElementPolicy = 'block';
